<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-header>
                <i class="icon-menu mr-1"></i>Data Table Mobile Banner
            </b-card-header>
            <b-card-body>
                <banner></banner>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import Banner from './Table'
export default {
    name: 'Index-banner',
    components: {
        Banner,
    },
}
</script>